export default "__VITE_ASSET__e693ea8a__"